import { w as r } from "./index-CUsW7EJU.js";
export {
  r as analytics
};
